module.exports = __webpack_public_path__ + "static/media/search.780f4bc6.svg";